import {dividerClasses} from '@mui/material/Divider'
import {mobileStepperClasses} from '@mui/material/MobileStepper'
import {createTheme, responsiveFontSizes} from '@mui/material/styles'

import {SECONDARY_MAIN} from './tokens'

// Keep PURE: a `styled` reading this at module scope stays a static object, not a callback emotion
// re-serializes per instance per render.
export const appTheme = responsiveFontSizes(createTheme({
  palette: {
    secondary: {
      main: SECONDARY_MAIN,
    },
  },
  components: {
    MuiSelect: {
      styleOverrides: {
        select: {
          minHeight: '1.4375em',
          maxHeight: '1.4375em',
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        // The listbox inside is the scroller (`AutocompleteListbox`).
        paper: {overflow: 'hidden'},
      },
    },
    MuiDialog: {
      styleOverrides: {
        // The body inside is the scroller (`DialogScroll`); the paper would add a second one around the
        // title and the actions.
        paper: {
          overflow: 'hidden',
          '&:focus-visible': {
            outline: 'none',
          },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        message: {
          flex: 1,
        },
      },
    },
    MuiStack: {
      styleOverrides: {
        root: {
          [`>.${dividerClasses.vertical}:last-child`]: {
            display: 'none',
          },
          [`>.${dividerClasses.vertical}:first-child`]: {
            display: 'none',
          },
        },
      },
    },
    MuiMobileStepper: {
      styleOverrides: {
        root: {
          gap: 8,
          [`>.${mobileStepperClasses.progress}`]: {
            flex: 1,
          },
        },
      },
    },
  },
}))
